import { Action, createReducer, on } from '@ngrx/store';
import * as ReplaceBillingitemsWizardActions from './actions';
import { State, initialState } from './state';

export const replaceBillingitemsWizardFeatureKey = 'replaceBillingitemsWizardV26';

const replaceBillingitemsWizardReducer = createReducer(
  initialState,

  on(ReplaceBillingitemsWizardActions.selectInitStep, (state, { initStep }) => ({
    ...state,
    initStep,
    dueDatesStep: { activationDate: null },
  })),
  on(ReplaceBillingitemsWizardActions.selectDueDatesStep, (state, { dueDatesStep }) => ({
    ...state,
    dueDatesStep,
  })),
  on(ReplaceBillingitemsWizardActions.selectServiceStep, (state, { serviceStep }) => ({
    ...state,
    serviceStep,
  })),
  on(ReplaceBillingitemsWizardActions.deleteServiceStep, (state) => ({
    ...state,
    serviceStep: null,
  })),
  on(ReplaceBillingitemsWizardActions.exitReplaceBillingitemsWizard, (state) => ({
    ...state,
    initStep: null,
    dueDatesStep: null,
    serviceStep: null,
    errorMessage: null,
    request: null,
    response: null,
  })),
  on(ReplaceBillingitemsWizardActions.destroyWizard, (state) => ({
    ...state,
    initStep: null,
    dueDatesStep: null,
    serviceStep: null,
    errorMessage: null,
    request: null,
    response: null,
  })),
  on(ReplaceBillingitemsWizardActions.createNewReplaceBillingitems, (state, { request }) => ({
    ...state,
    request,
  })),
  on(ReplaceBillingitemsWizardActions.createNewReplaceBillingitemsSuccess, (state, { response }) => ({
    ...state,
    response,
  })),
  on(ReplaceBillingitemsWizardActions.createNewReplaceBillingitemsFail, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return replaceBillingitemsWizardReducer(state, action);
}
